import {
  DefaultTemplateTaskAutomationModel,
  WorkTemplateTaskModel,
} from "../../../../../factories/templates/models/template.model";
import {
  AutomationActionModel,
  AutomationActionValue,
  AutomationJobTaskConditionModel,
  AutomationSerializedValue,
} from "../../../../../slices/AutomationSlice";
import {
  AutomationItem,
  AutomationLookupOptions,
} from "../../../../work/pages/automation/automation.constants";
import {
  parseAutomationActionValue,
  parseAutomationConditionValue,
  resolveOptionLabel,
} from "../../../../work/pages/automation/automation.helpers";

const getSerializedAutomationValue = (
  value: AutomationSerializedValue | AutomationActionValue | undefined,
): AutomationSerializedValue | undefined => {
  if (typeof value === "string" || value === null || value === undefined) {
    return value;
  }

  return JSON.stringify(value);
};

const createAutomationMaps = (
  conditions: AutomationJobTaskConditionModel[],
) => {
  const conditionById = new Map<string, AutomationJobTaskConditionModel>();
  const actionById = new Map<string, AutomationActionModel>();

  conditions.forEach((condition) => {
    conditionById.set(condition.id, condition);
    condition.jobTaskConditionAction.forEach(({ action }) => {
      actionById.set(action.id, action);
    });
  });

  return { conditionById, actionById };
};

export const getFirstTemplateTaskAutomation = (
  subtask: WorkTemplateTaskModel,
): DefaultTemplateTaskAutomationModel | undefined => {
  return subtask.defaultTemplateTaskAutomation?.[0];
};

export const mapTemplateTaskAutomationToItem = ({
  automation,
  subtask,
  options,
  jobTaskConditions,
}: {
  automation: DefaultTemplateTaskAutomationModel;
  subtask: Pick<WorkTemplateTaskModel, "id" | "name">;
  options: AutomationLookupOptions;
  jobTaskConditions: AutomationJobTaskConditionModel[];
}): AutomationItem => {
  const { conditionById, actionById } = createAutomationMaps(jobTaskConditions);
  const condition =
    automation.condition ?? conditionById.get(automation.conditionId);
  const action = automation.action ?? actionById.get(automation.actionId);

  return {
    id: automation.id,
    scope: "subtask",
    subtaskId: subtask.id,
    subtaskTitle: subtask.name || "Selected subtask",
    conditionId: automation.conditionId,
    conditionKey: condition?.conditionKey,
    conditionValue: parseAutomationConditionValue(
      getSerializedAutomationValue(automation.conditionValue),
    ),
    actionId: automation.actionId,
    actionKey: action?.actionKey,
    actionValue: parseAutomationActionValue(
      getSerializedAutomationValue(automation.actionValue),
    ),
    createdBy: resolveOptionLabel(options, "users", "", "Unknown user"),
    // Not "Created by Unknown user" (QA batch 14): template automations have no creator.
    sourceText: "Added to this subtask template",
    createdAt: automation.createdAt,
    lastRunAt: undefined,
    lastRunStatus: "idle",
  };
};
